import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';
import { ErrorRefreshButton } from '@/components/ErrorRefreshButton/ErrorRefreshButton';
import { ErrorPageRoot } from '../../components/ErrorPageRoot/ErrorPageRoot';
import {
  ErrorPageBodyContainer,
  ErrorPageErrorContainer,
  ErrorPageMainHeaderContainer,
  ErrorPageSubHeaderContainer,
  ErrorPageSubTextContainer,
} from './../../components/ErrorPageRoot/ErrorPageRoot.styles';
import { ErrorMessages } from '@/common/Layouts/CommonHeader/constants';
import { useLagoon } from '@/hooks/useLagoon';
import { formatLagoonData } from '../../utils/formatLagoonData';

export const PageNotFound = () => {
  const data = useLagoon('container-ui-messaging')();
  const ErrorMessage = formatLagoonData(data, ErrorMessages);
  return (
    <ErrorPageRoot>
      <ErrorPageBodyContainer>
        <ErrorPageErrorContainer>
          <Text color="$interactive2" fontWeight="$bold" size="$xs">
            {ErrorMessage[ErrorMessages.ERROR_404]?.title}
          </Text>
        </ErrorPageErrorContainer>
        <ErrorPageMainHeaderContainer>
          <Heading> {ErrorMessage[ErrorMessages.UH_OH]?.title}</Heading>
        </ErrorPageMainHeaderContainer>
        <ErrorPageSubHeaderContainer>
          <Heading offset={5}>
            {' '}
            {ErrorMessage[ErrorMessages.ERROR_PAGE_TEXT]?.title}
          </Heading>
        </ErrorPageSubHeaderContainer>
        <ErrorPageSubTextContainer>
          <Text size="$sm">
            {ErrorMessage[ErrorMessages.ERROR_PAGE_SUBTEXT]?.title}
          </Text>
          <ErrorRefreshButton
            buttonText={ErrorMessage[ErrorMessages.REFRESH]?.title ?? 'Refresh'}
          />
        </ErrorPageSubTextContainer>
      </ErrorPageBodyContainer>
    </ErrorPageRoot>
  );
};
